import { TiresLeadsFilters } from "modules/LeadsDashboard/Leads/TiresLeads/components";

export const TiresLeads = () => <TiresLeadsFilters />;
